import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyB9PFzfirZXlnBcWW-yCk3X0FaVApRuGo8",
  authDomain: "spend-easy-web.firebaseapp.com",
  projectId: "spend-easy-web",
  storageBucket: "spend-easy-web.firebasestorage.app",
  messagingSenderId: "706217431797",
  appId: "1:706217431797:web:07016fa5f9f6a51c756bbc",
  measurementId: "G-N59MF8RKNQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// Set auth persistence to local
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Firebase auth persistence set to LOCAL');
  })
  .catch((error) => {
    console.error('Error setting persistence:', error);
  });

// Initialize analytics (optional)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;
